// ModalEditOwnerBeforeSave
import { Modal, Form, Input, Select, Button, Space, Row } from "antd";
import React, { useEffect } from "react";

function ModalEditOwnerBeforeSave({
  open,
  close,
  dataEditOwner,
  handledataNewOwnerBefore,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (dataEditOwner) {
      form.setFieldsValue({
        relation: dataEditOwner.relation,
        assetType: dataEditOwner.assetType,
        cuscod: dataEditOwner.assetCustomer?.cuscod,
        snam: dataEditOwner.assetCustomer?.snam,
        fname: dataEditOwner.assetCustomer?.fname,
        lname: dataEditOwner.assetCustomer?.lname,
      });
    }
  }, [dataEditOwner, form]);

  // console.log("dataEditOwner", dataEditOwner);

  const handleFinish = async (values) => {
    const params = { ...values };
    handledataNewOwnerBefore(params);
    handleClose();
  };

  const handleClose = () => {
    close(false);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      width={400}
      footer={null}
      title="แก้ไขเจ้าของทรัพย์"
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          relation: "",
          assetType: "",
        }}
      >
        <Form.Item
          label="รหัสลูกค้า"
          name="cuscod"
          rules={[{ required: true, message: "กรุณากรอกรหัสลูกค้า" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="คำนำหน้า"
          name="snam"
          rules={[{ required: true, message: "กรุณากรอกคำนำหน้า" }]}
        >
          <Select
            style={{ height: "40px" }}
            options={[
              { label: "นาย", value: "นาย" },
              { label: "นาง", value: "นาง" },
              { label: "นางสาว", value: "นางสาว" },
            ]}
            placeholder="เลือกคำนำหน้า"
          />
        </Form.Item>

        <Form.Item
          label="ชื่อ"
          name="fname"
          rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="นามสกุล"
          name="lname"
          rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="ความสัมพันธ์"
          name="relation"
          rules={[{ required: true, message: "กรุณากรอกความสัมพันธ์" }]}
        >
          <Input placeholder="เช่น เพื่อน, ญาติ" />
        </Form.Item>

        <Row justify={"center"}>
          <Space>
            <Button onClick={handleClose}>ยกเลิก</Button>
            <Button type="primary" htmlType="submit">
              บันทึก
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
}

export default ModalEditOwnerBeforeSave;
